const usersTypes = {
    SET_LAST_STATE_CHECK: 'SET_LAST_STATE_CHECK',
    CREATE_START: 'CREATE_START',
    CREATE_FAILURE: 'CREATE_FAILURE',
    CREATE_SUCCESS: 'CREATE_SUCCESS',
    LOGIN_START: 'LOGIN_START',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    LOGGED_IN: 'LOGGED_IN',
    LOGOUT: 'LOGOUT',
};

export default usersTypes;
